import { render } from "./LunchView.vue?vue&type=template&id=042b953a"
import script from "./LunchView.vue?vue&type=script&lang=js"
export * from "./LunchView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__